import { render, staticRenderFns } from "./ListDepartmentPage.vue?vue&type=template&id=37557e3e&"
import script from "./ListDepartmentPage.vue?vue&type=script&lang=js&"
export * from "./ListDepartmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports